import React from "react";

const Footer = () => {
  return (
    <div className="container ">
        <div className="row mt-5 p-3  bg-light">
      <div className="col-md-6">
        <h2>Stay up to Date</h2>
        <p>Don't miss the latest offer.</p>
        <div class="input-group mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="Email"
            aria-label="Recipient's username"
            aria-describedby="button-addon2"
          />
          <button
            class="btn btn-outline-secondary"
            type="button"
            id="button-addon2"
          >
            Send
          </button>
        </div>
      </div>
      <div className="col-md-6">
          <h1 className="text-center bold">DrivingLab</h1>
          <div className="p-2">
          <i class="bi bi-facebook p-2 fs-5"></i>
          <i class="bi bi-whatsapp p-2 fs-5"></i>
          <i class="bi bi-linkedin p-2 fs-5"></i>
          <i class="bi bi-youtube p-2 fs-5" ></i>
          </div>
      </div>
    </div>
    </div>
  );
};

export default Footer;
